module.exports = __webpack_public_path__ + "static/2021-03-26-15-25-31-961-fs8-fs8-3620f1a41771817ac57169767bf89f24.png";